export enum Role {
    ADMIN = 'ROLE_ADMIN',
    CRIS_USER = 'ROLE_CRIS',
    CRIS_MANAGER = 'ROLE_CRIS_MANAGER',
    TAXONOMY_ADMIN = 'ROLE_TAXONOMY_ADMIN',
    PARTNER_MAPPING_RW = 'ROLE_PARTNER_MAPPING_RW',
    QA_MANAGER = 'ROLE_QA_MANAGER',
    QA_REJECT = 'ROLE_QA_REJECT',
    ROOT = 'ROLE_ROOT',
    SEAM_MANAGER = 'ROLE_SEAM_MANAGER',
    SEAM_REQUESTS = 'ROLE_SEAM_REQUESTS',
    TUNER = 'ROLE_TUNER',
    USER = 'ROLE_USER',
    DASHBOARD_USER = 'ROLE_KPI_DASHBOARD',
    SEAM_PROCESS_ADMIN = 'ROLE_SEAM_PROC_ADMIN',
}
